import axiosInstance from './AxiosInstance';

const API_URL = 'jobtypes';

export const getJobTypes = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching jobtypes', error);
        throw error;
    }
};

export const getJobTypeById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching jobtype with id ${id}`, error);
        throw error;
    }
};

export const createJobType = async (jobtype) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, jobtype);
        return response.data;
    } catch (error) {
        console.error('Error creating jobtype', error);
        throw error;
    }
};

export const updateJobType = async (id, jobtype) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...jobtype });
        return response.data;
    } catch (error) {
        console.error(`Error updating jobtype with id ${id}`, error);
        throw error;
    }
};

export const deleteJobType = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting jobtype with id ${id}`, error);
        throw error;
    }
};

